export const routesAdmin = [
  {
    path: "/resimonay/:dugunId",
    name: "resimonay",
    component: () => import("@/views/resimonay/index.vue"),
    meta: {
      public: false,
      title: "Resim Onay",
      yetki: { k: [], a: true },
    },
  },

  {
    path: "/parametre",
    name: "parametre",
    component: () => import("@/views/parametre/index.vue"),
    meta: {
      public: false,
      title: "Parametre",
      yetki: { k: [], s: true },
    },
  },
]
